import { z } from 'zod';
import { TMDXFile } from '@/api/apis/files';
import { getPhoneSchema } from '@/utils/helpers';
import { NewLogisticProviderForm } from './types';

export const DEFAULT_LOGISTIC_PROVIDER_VALUES: NewLogisticProviderForm = {
  name: '',
  email: '',
  primaryPhone: '',
  secondaryPhone: '',
  aircraftType: '',
  coverage: {},
  country: null,
  state: null,
  addressLine: null,
  city: null,
  postalCode: null,
  timezone: null,
  timezoneIANA: '',
  logoPath: '',
};

export const logisticProviderSchema = z.object({
  name: z.string().trim().min(1, 'Provide donor hospital name'),
  email: z.string().trim().min(1, 'Provide email'),
  primaryPhone: getPhoneSchema({ isRequired: true }),
  secondaryPhone: getPhoneSchema({ isRequired: false }),
  image: z.custom<TMDXFile>().optional(),
  logoPath: z.string().optional(),
  aircraftType: z.string().nullable(),
  coverage: z.record(z.string(), z.array(z.string())),
  country: z.string().nullable(),
  state: z.string().nullable(),
  addressLine: z.string().nullable(),
  city: z.string().nullable(),
  postalCode: z.string().nullable(),
  timezone: z.string().nullable(),
  timezoneIANA: z.string(),
});

export const logisticProviderFormSchema = logisticProviderSchema;
